export const helpers = {
  hasPermission: (adminData, permission) => {
    if (!adminData) return false;

    const access = adminData.access;
    if (Array.isArray(access)) {
      if (access.includes('all')) return true;
    }

    const permissions = adminData.permissions;
    if (!permissions || !Array.isArray(permissions)) return false;

    if (permissions.includes('all')) return true;
    return permissions.includes(permission);
  },
};
